import * as audio from './kernel/audio.js';
import * as dom from './dom.js';
import * as scene from './scene.js';

export {
    start,
}

// Development
window.DEVMODE = true;

function init() {
    dom.init();
    dom.status('Initializing...');

    audio.init();

    dom.status('Loading...');

    scene.init();
    scene.load().then(() => {
        dom.showStart();
    });
}

function start() {
    scene.start();
}

init();
